import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[appResize]'
})
export class ResizeDirective {
    @Input() leftResize: HTMLElement;
    @Input() rightResize: HTMLElement;

    grabber = false;
    width: number;
    offsetWidthLeft = 0;

    constructor(private el: ElementRef<HTMLElement>) {}
    @HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent) {
        this.grabber = true;
        this.offsetWidthLeft = event.clientX - this.leftResize.offsetWidth - this.el.nativeElement.offsetWidth;
        document.body.style.cursor = 'e-resize';
    }

    @HostListener('window:mouseup') onMouseUp() {
        this.grabber = false;
        document.body.style.cursor = 'default';
    }

    @HostListener('window:mousemove', ['$event']) onMouseMove(event: MouseEvent) {
        if (this.grabber) {
            event.preventDefault();
            if (this.leftResize.style && this.rightResize.style) {
                if (this.leftResize.style.maxWidth) {
                    this.leftResize.style.removeProperty('max-width');
                }
                if (this.rightResize.style.maxWidth) {
                    this.rightResize.style.removeProperty('max-width');
                }

                const curTotalWidth = this.leftResize.offsetWidth + this.rightResize.offsetWidth + this.el.nativeElement.offsetWidth;

                if (event.movementX > 0) {
                    this.rightResize.style.flex = `1 1 ${curTotalWidth - event.clientX + this.offsetWidthLeft}px`;
                    this.leftResize.style.flex = `1 1 ${event.clientX - this.offsetWidthLeft - this.el.nativeElement.offsetWidth / 2}px`;
                } else {
                    this.leftResize.style.flex = `1 1 ${event.clientX - this.offsetWidthLeft - this.el.nativeElement.offsetWidth / 2}px`;
                    this.rightResize.style.flex = `1 1 ${curTotalWidth - event.clientX + this.offsetWidthLeft}px`;
                }
            }
        }
    }
}
